import { capitalizeFirstLetter } from '../../CancelBooking/CancelSummary';

export const getRefundTable = (props: any) => {
  const orgCode = props?.data?.userOrganization?.organizationCode;
  const orderAmount = props?.data?.orderAmount;
  const currency = orderAmount?.currency;
  const totalAmount = orderAmount?.totalAmount ?? 0;
  const amountInCash = orderAmount?.paymentSummary?.amountInCash ?? 0;
  const amountInCoins = orderAmount?.paymentSummary?.amountInCoins ?? 0;
  const paymentMode = orderAmount?.paymentSummary?.paymentMode;
  const additionalInfo = orderAmount?.paymentSummary?.refundSummary?.additionalInfo;
  const refundCharges = additionalInfo?.totalRefundCharges ?? 0;
  const refundSummary = props?.data?.orderAmount?.paymentSummary?.refundSummary;
  const nonRefundableFeeCharges = additionalInfo?.totalNonRefundableFeeCharges;
  const convenienceFeeCharges = additionalInfo?.convenienceFeeCharges ?? 0;
  const totalRefundAmount = refundSummary?.totalRefundAmount ?? 0;
  const refundAmountInCash = refundSummary?.refundAmountInCash ?? 0;
  return [
        {
          id: 1,
          label: 'A. Amount paid',
          value: `${currency} ${totalAmount ?? 0}`,
          header: true
        },
        {
          id: 2,
          label: `Paid by customer (via ${
            paymentMode ? paymentMode?.replace(/_/g, ' ')?.toLowerCase() : 'UPI'
          })`,
          value: `${currency} ${amountInCash ?? 0}`,
          header: false
        },
        {
          id: 3,
          label: `${
            !orgCode || orgCode?.toLowerCase()?.includes('niyo')
              ? 'Niyo global coins discount'
              : `${capitalizeFirstLetter(orgCode)} discount`
          }`,
          value: `${currency} ${amountInCoins ?? 0}`,
          header: false,
          success: true
        },
        {
          id: 4,
          label: 'B. Cancellation charges',
          value: `- ${currency} ${parseFloat(refundCharges)}`,
          header: true
        },
        {
          id: 5,
          label: 'Cancellation Fee',
          value: `${currency} ${refundCharges}`,
          header: false
        },
        {
          id: 6,
          label: 'C. Non refundable',
          value: `- ${currency} ${nonRefundableFeeCharges}`,
          header: true
        },
        {
          id: 7,
          label: 'Convenience fee',
          value: `${currency} ${convenienceFeeCharges}`,
          header: false
        },
        {
          id: 8,
          label: 'Total refund amount',
          value: `${currency} ${totalRefundAmount}`
        },
        {
          id: 9,
          label: 'Refunded to Bank A/C',
          value: `${currency} ${refundAmountInCash}`
        }
      ]

};

export const cancelTableData = (props: any) => {
  const orderAmount = props?.hotelData?.orderAmount;
  const orgCode = props?.hotelData?.userOrganization?.organizationCode;
  const currency = orderAmount?.currency;
  const totalAmount = orderAmount?.totalAmount;
  const amountInCash = orderAmount?.paymentSummary?.amountInCash;
  const amountInCoins = orderAmount?.paymentSummary?.amountInCoins;
  const convenienceFee = orderAmount?.paymentSummary?.convenienceFee;
  const totalRefundCharges = props?.refundInfo?.totalRefundCharges ?? 0;
  const totalRefundAmount = props?.refundInfo?.totalRefundAmount ?? 0;
  const totalNonRefundableFeeCharges = props?.refundInfo?.totalNonRefundableFeeCharges ?? 0;

  return [
    {
      id: 1,
      label: 'A. Amount paid',
      value: `${currency} ${totalAmount}`,
      header: true
    },
    {
      id: 2,
      label: `Paid by customer (via ${
        props?.flightData?.orderAmount?.paymentSummary?.paymentMode
          ? props?.flightData?.orderAmount?.paymentSummary?.paymentMode
              ?.replace(/_/g, ' ')
              ?.toLowerCase()
          : 'UPI'
      })`,
      value: `${currency} ${amountInCash}`,
      header: false
    },
    {
      id: 3,
      label: `${
        !orgCode || orgCode?.toLowerCase()?.includes('niyo')
          ? 'Niyo global coins discount'
          : `${capitalizeFirstLetter(orgCode)} discount`
      }`,
      value: `${currency} ${amountInCoins}`,
      header: false,
      success: true
    },
    {
      id: 4,
      label: 'B. Cancellation charges',
      value: `- ${currency} ${totalRefundCharges}`,
      header: true
    },
    {
      id: 5,
      label: 'Cancellation Fee',
      value: `INR ${totalRefundCharges}`,
      header: false
    },
    {
      id: 6,
      label: 'C. Non refundable',
      value: `- ${currency} ${totalNonRefundableFeeCharges}`,
      header: true
    },
    {
      id: 7,
      label: 'Convenience fee',
      value: `${currency} ${convenienceFee}`,
      header: false
    },
    {
      id: 8,
      label: 'Total refund amount',
      value: `${currency} ${totalRefundAmount}`
    }
  ];
};
